import {MaterialReactTable, useMaterialReactTable} from 'material-react-table'
import Actions from './Actions'
import {useI18n, useIsRtl} from 'store/Store'
import {MRT_Localization_HE} from 'material-react-table/locales/he'
import dayjs from 'services/utils/dayjs'
import {PAGE_SIZES} from 'constants/tables'

const TableComponent = ({
    columns,
    data,
    allowEdit,
    allowDelete,
    editOrCreateItem,
    totalItems,
    isLoading,
    paginationType,
    allowView,
    onViewItem,
    pagination,
    setPagination,
    setColumnFilters,
    setSorting,
    columnFilters,
    sorting,
    tableSearch,
    setTableSearch,
    setColumnVisibility,
    columnVisibility = {},
    additionalActions,
    handleDelete,
}) => {
    const {i18n} = useI18n()
    const isRtl = useIsRtl()

    const otherElementsHeight = 382

    const table = useMaterialReactTable({
        columns,
        data,
        layoutMode: 'grid',
        columnResizeMode: 'onChange',
        columnResizeDirection: isRtl ? 'rtl' : 'ltr',
        localization: isRtl && MRT_Localization_HE,
        getRowId: (row) => row._id,
        enableColumnResizing: true,
        enableColumnActions: true,
        enableRowActions: allowEdit || allowDelete || allowView,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: i18n.t('tables.actions'),
                size: 70,
            },
        },
        enableStickyHeader: true,
        enableStickyFooter: true,
        positionActionsColumn: 'last',
        renderRowActions: ({row}) => (
            <Actions
                row={row}
                allowEdit={allowEdit}
                allowDelete={allowDelete}
                allowView={allowView}
                handleDelete={handleDelete}
                handleEdit={editOrCreateItem}
                handleView={onViewItem}
                additionalActions={additionalActions}
            />
        ),
        rowCount: totalItems || 0,
        isLoading,
        initialState: {
            density: 'compact',
            columnPinning: {right: ['mrt-row-actions']},
            showGlobalFilter: true,
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: `calc(100vh - ${otherElementsHeight}px)`,
                overflowX: 'auto',
            },
        },
        muiTablePaperProps: {
            variant: 'outlined',
            elevation: 0,
            sx: {
                maxHeight: '85%',
                overflowX: 'hidden',
                '& .MuiFormControl-root': {
                    backgroundColor: '#f5f5f5',
                },
                '& .MuiSelect-select': {
                    paddingBlock: '4.5px',
                },
                '& .MuiSelect-select .MuiChip-root': {
                    height: 'auto',
                },
                '& .MuiInputAdornment-root span': {
                    width: 32,
                },
                '& .MuiSelect-select.MuiInputBase-input': {
                    paddingRight: 4,
                },
            },
        },
        muiBottomToolbarProps: {
            sx: {
                minHeight: '56px',
            },
        },
        muiTableHeadCellProps: {
            align: 'center',
            sx: {
                background: '#F5F5F5',
            },
        },
        muiTableBodyCellProps: {
            align: 'center',
        },
        muiTopToolbarProps: {
            sx: {background: '#F5F5F5'},
        },
        muiCopyButtonProps: {
            sx: {
                fontWeight: 'normal',
            },
        },
        muiFilterDatePickerProps: ({column}) => ({
            value:
                column.getFilterValue() && dayjs.utc(column.getFilterValue()),
            format: 'DD/MM/YYYY',
        }),
        manualPagination: paginationType === 'external',
        onPaginationChange: setPagination,
        muiPaginationProps: {
            rowsPerPageOptions: PAGE_SIZES,
        },
        manualFiltering: true,
        onGlobalFilterChange: setTableSearch,
        onColumnFiltersChange: setColumnFilters,
        enableFilterMatchHighlighting: false,
        manualSorting: true,
        onSortingChange: setSorting,
        onColumnVisibilityChange: setColumnVisibility,
        state: {
            pagination,
            sorting,
            globalFilter: tableSearch,
            columnFilters,
            columnVisibility,
            isLoading,
        },
    })

    return <MaterialReactTable table={table} />
}

export default TableComponent
